import React from 'react';
import { shape, string, arrayOf } from 'prop-types';
import { Carousel } from '@thd-olt-component-react/carousel';
import { Price } from '@thd-olt-component-react/price';
import { Image } from '@thd-olt-component-react/image';
import { sanitizeImageUrl } from '../../../../utils/promo-utils';
import './PromoQuickviewDetails.scss';

export const PromoQuickviewDetails = ({
  storeId, itemId, brand, description, images
}) => {
  return (
    <section className="promo-quickview-details">
      <p className="promo-quickview-details__desc">
        <span className="u__bold">{brand}</span> {description}
      </p>
      {images.length > 0 && (
        <div className="promo-quickview-details-carousel">
          <Carousel
            showArrows
            dotBelow
            showDots
            multiItem={false}
          >
            {images.map((image, i) => (
              <div
                className="promo-quickview-details-carousel__image-wrapper"
                key={`promo-quickview-details-carousel-image-${i}`}
              >
                <Image
                  alt={image.type}
                  src={sanitizeImageUrl(image.url)}
                  lazy
                />
              </div>
            ))}
          </Carousel>
        </div>
      )}
      <Price
        large
        itemId={itemId}
        storeId={storeId}
        displayEachUom={false}
        basic
        hideBadge
        hidePromotions
        hideBulkPrice
        disableRangePricing
      />
    </section>
  );
};

PromoQuickviewDetails.displayName = 'PromoQuickviewDetails';

PromoQuickviewDetails.propTypes = {
  storeId: string.isRequired,
  itemId: string.isRequired,
  brand: string.isRequired,
  description: string.isRequired,
  images: arrayOf(shape({
    url: string,
    type: string,
  })).isRequired,
};
